export default "__VITE_ASSET__BpnsTJ2L__"